module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ser":"Our Services","ab":"Contact Us","rep":"Send a repair"},"el":{"ser":"Υπηρεσίες","ab":"Επικοινωνία","rep":"Αποστολή επισκευής"}}')
  delete Component.options._Ctor
}
